<template>
  <div class="tool-page">
    <div class="tool-content">
      <!-- ===== 列表视图 ===== -->
      <template v-if="!detailItem">
        <div class="tool-heading">
          <div>
            <h2>聚合好物</h2>
            <p>精选带货素材，标题、口播文案、视频、商品图一键提取</p>
          </div>
          <app-icon  class="app-icon" name="shopping_bag"></app-icon>
        </div>

        <div class="tool-card">
          <div class="search-bar">
            <el-input v-model="findValue" placeholder="搜索商品名称" clearable
              @keyup.enter.native="search" @clear="search"></el-input>
            <el-button type="primary" @click="search">查找</el-button>
          </div>

          <div class="type-tabs">
            <span v-for="t in types" :key="t" class="type-chip" :class="{ active: type === t }"
              @click="switchType(t)">{{ t }}</span>
          </div>

          <div v-if="list.length" class="goods-grid">
            <div v-for="(item, index) in list" :key="item.id" class="goods-card" @click="openDetail(item)">
              <div class="goods-cover">
                <span v-if="isTop20(index)" class="goods-new">新</span>
                <el-image :src="item.cover" fit="cover" class="goods-cover-img">
                  <div slot="error" class="img-error">
                    <app-icon  class="app-icon" name="image"></app-icon>
                  </div>
                </el-image>
                <div class="goods-hover">
                  <app-icon  class="app-icon" name="open_in_new"></app-icon>
                  查看详情
                </div>
              </div>
              <div class="goods-info">
                <div class="goods-detail-link">查看素材 <i class="el-icon-arrow-right"></i></div>
                <div class="goods-name" :title="item.name">{{ item.name }}</div>
                <div class="goods-meta">
                  <span class="goods-date">{{ item.timestamp || '—' }}</span>
                  <span class="goods-dj">{{ item.dj || 0 }}人使用</span>
                </div>
              </div>
            </div>
          </div>
          <el-empty v-else-if="!loading" description="暂无好物素材" :image-size="120"></el-empty>

          <div v-if="total > pageSize" class="pagination-row">
            <el-pagination background layout="prev, pager, next, total" :page-size="pageSize"
              :total="total" :current-page="page" @current-change="changePage"></el-pagination>
          </div>
        </div>
      </template>

      <!-- ===== 详情视图 ===== -->
      <template v-else>
        <div class="detail-back" @click="backList">
          <app-icon  class="app-icon" name="arrow_back"></app-icon>
          返回列表
        </div>

        <div class="detail-header">
          <div class="detail-cover">
            <el-image :src="detailItem.cover" fit="cover">
              <div slot="error" class="img-error">
                <app-icon  class="app-icon" name="image"></app-icon>
              </div>
            </el-image>
          </div>
          <div class="detail-main">
            <div class="detail-name">{{ detailItem.name }}</div>
            <div class="detail-meta">
              <span class="goods-dj">{{ detailItem.dj || 0 }}人使用</span>
              <span v-if="detailItem.timestamp" class="detail-date">{{ detailItem.timestamp }} 更新</span>
            </div>
            <div class="detail-actions">
              <el-button type="primary" size="medium" @click="makeDialog = true">
                <app-icon  class="app-icon btn-icon" name="auto_fix_high"></app-icon>高级制作
              </el-button>
              <el-button type="primary" plain size="medium" :loading="quicking" @click="quickFc">
                <app-icon  class="app-icon btn-icon" name="bolt"></app-icon>快速生成（今日剩 {{ kuaisuRemain }} 次）
              </el-button>
              <el-button v-if="kuaisuRemain <= 3" size="medium" type="warning" plain @click="resetKuaisu">
                分享好友领次数
              </el-button>
            </div>
          </div>
        </div>

        <div class="tool-card detail-card">
          <el-tabs v-model="activeTab">
            <el-tab-pane :label="`视频素材${fileTotal ? ' (' + fileTotal + ')' : ''}`" name="files">
              <template v-if="fileTotal > 0">
                <div v-if="audioGroup.total > 0" class="file-section">
                  <div class="file-section-title">
                    <app-icon  class="app-icon" name="music_note"></app-icon>
                    音频
                  </div>
                  <div class="file-grid">
                    <div v-for="(item, index) in audioGroup.list" :key="'a' + index" class="file-item">
                      <div class="file-cover" @click="playFile(item)">
                        <el-image :src="item.image || item.url" fit="cover">
                          <div slot="error" class="img-error">
                            <app-icon  class="app-icon" name="music_note"></app-icon>
                          </div>
                        </el-image>
                        <div class="file-play">
                          <app-icon  class="app-icon" name="music_note"></app-icon>
                        </div>
                      </div>
                      <div class="file-name" :title="item.name">{{ item.name }}</div>
                      <div class="file-actions">
                        <el-button size="mini" @click="playFile(item)">播放</el-button>
                        <el-button size="mini" type="primary" plain @click="download(item.url, item.name)">下载</el-button>
                      </div>
                    </div>
                  </div>
                  <div v-if="audioGroup.total > audioGroup.list.length" class="load-more">
                    <el-button size="small" :loading="audioGroup.loading" @click="loadFiles('音乐', true)">加载更多</el-button>
                  </div>
                </div>

                <div v-for="section in videoSections" :key="section.name" class="file-section">
                  <div class="file-section-title">
                    <app-icon  class="app-icon" name="video_library"></app-icon>
                    {{ section.name }}片段
                  </div>
                  <div class="file-grid">
                    <div v-for="(item, index) in section.list" :key="section.name + index" class="file-item">
                      <div class="file-cover" @click="playFile(item)">
                        <el-image :src="item.image || item.url" fit="cover">
                          <div slot="error" class="img-error">
                            <app-icon  class="app-icon" name="video_file"></app-icon>
                          </div>
                        </el-image>
                        <div class="file-play">
                          <app-icon  class="app-icon" name="play_arrow"></app-icon>
                        </div>
                      </div>
                      <div class="file-name" :title="item.name">{{ item.name }}</div>
                      <div class="file-actions">
                        <el-button size="mini" @click="playFile(item)">播放</el-button>
                        <el-button size="mini" type="primary" plain @click="download(item.url, item.name)">下载</el-button>
                      </div>
                    </div>
                  </div>
                  <div v-if="section.total > section.list.length" class="load-more">
                    <el-button size="small" :loading="section.loading" @click="loadFiles(section.name, true)">加载更多</el-button>
                  </div>
                </div>
              </template>
              <el-empty v-else description="暂无视频素材" :image-size="90"></el-empty>
            </el-tab-pane>

            <el-tab-pane label="标题" name="bt">
              <div v-if="bt.length" class="text-list">
                <div v-for="(item, index) in bt" :key="index" class="text-item">
                  <div class="text-content" @click="copy(item.text)">{{ item.text }}</div>
                  <el-button size="mini" plain @click="copy(item.text)">复制</el-button>
                </div>
              </div>
              <el-empty v-else description="暂无标题" :image-size="90"></el-empty>
            </el-tab-pane>

            <el-tab-pane label="口播文案" name="jb">
              <div v-if="jb.length" class="text-list">
                <div v-for="(item, index) in jb" :key="index" class="text-item">
                  <div class="text-content" @click="copy(item.text)">{{ item.text }}</div>
                  <el-button size="mini" plain @click="copy(item.text)">复制</el-button>
                </div>
              </div>
              <el-empty v-else description="暂无口播文案" :image-size="90"></el-empty>
            </el-tab-pane>

            <el-tab-pane :label="`商品图${imgTotal ? ' (' + imgTotal + ')' : ''}`" name="imgs">
              <div v-if="imgs.length" class="imgs-grid">
                <el-image v-for="(item, index) in imgs" :key="index" :src="item.thumb || item.url"
                  fit="cover" class="img-item" :preview-src-list="imgs.map(i => i.url)" :initial-index="index">
                  <div slot="error" class="img-error">
                    <app-icon  class="app-icon" name="broken_image"></app-icon>
                  </div>
                </el-image>
              </div>
              <el-empty v-else-if="!imgLoading" description="暂无商品图" :image-size="90"></el-empty>
              <div v-if="imgTotal > imgs.length" class="load-more">
                <el-button size="small" :loading="imgLoading" @click="loadImgs(true)">加载更多</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </div>

    <!-- 制作弹窗 -->
    <el-dialog title="高级制作" :visible.sync="makeDialog" custom-class="haowu2-dialog" width="440px">
      <div class="make-box">
        <div class="make-name">{{ detailItem && detailItem.name }}</div>
        <div class="make-row">
          <span>制作数量</span>
          <el-input-number v-model="makeNum" :min="1" :max="10" size="small"></el-input-number>
        </div>
        <div class="make-row">
          <span>单个费用</span>
          <span>{{ detailItem ? detailItem.surplus : 0 }} 点</span>
        </div>
        <div class="make-row">
          <span>总费用</span>
          <strong class="make-total">{{ detailItem ? detailItem.surplus * makeNum : 0 }} 点</strong>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="makeDialog = false">取消</el-button>
        <el-button type="primary" :loading="making" @click="makeFc">确认制作</el-button>
      </span>
    </el-dialog>

    <!-- 素材播放弹窗 -->
    <el-dialog title="素材预览" :visible.sync="playShow" custom-class="haowu2-dialog" width="720px">
      <video v-if="playFileItem && playFileItem.type !== 1" :src="playFileItem.url" controls autoplay
        class="play-video"></video>
      <audio v-else-if="playFileItem" :src="playFileItem.url" controls autoplay class="play-audio"></audio>
    </el-dialog>

    <!-- 快速生成预览弹窗 -->
    <el-dialog title="快速生成成功" :visible.sync="previewShow" custom-class="haowu2-dialog" width="720px"
      @closed="previewUrl = ''">
      <video v-if="previewUrl" :src="previewUrl" controls autoplay class="play-video"></video>
      <div v-else class="preview-empty">未获取到视频地址，请到制作记录查看</div>
      <div slot="footer" class="preview-actions">
        <el-button type="primary" :disabled="!previewUrl" @click="download(previewUrl, '快速生成视频.mp4')">下载视频</el-button>
        <el-button :disabled="!previewUrl" @click="copy(previewUrl)">复制链接</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'User2Haowu',
  data() {
    return {
      types: ['全部'],
      type: '全部',
      findValue: '',
      list: [],
      page: 1,
      total: 0,
      pageSize: 15,
      loading: false,
      detailItem: null,
      activeTab: 'files',
      bt: [],
      jb: [],
      fileGroups: {},
      fileGroupNames: ['开头', '中间', '结尾', '音乐'],
      imgs: [],
      imgPage: 1,
      imgTotal: 0,
      imgLoading: false,
      kuaisuRemain: 0,
      makeDialog: false,
      makeNum: 1,
      making: false,
      quicking: false,
      playShow: false,
      playFileItem: null,
      previewShow: false,
      previewUrl: ''
    }
  },
  computed: {
    fileTotal() {
      return Object.values(this.fileGroups).reduce((sum, g) => sum + (g.total || 0), 0)
    },
    audioGroup() {
      return this.fileGroups['音乐'] || { list: [], total: 0, loading: false }
    },
    videoSections() {
      return ['开头', '中间', '结尾']
        .map(name => ({ name, ...(this.fileGroups[name] || { list: [], total: 0, loading: false }) }))
        .filter(s => s.total > 0)
    }
  },
  methods: {
    loadTypes() {
      this.$ajax.get('api/v1/users/haowu/types').then(res => {
        if (res.data && res.data.status === 200) {
          this.types = ['全部'].concat(res.data.data || [])
        }
      }).catch(() => { })
    },
    loadList() {
      this.loading = true
      this.$ajax.get('api/v1/users/haowu/list', {
        params: { type: this.type, find: this.findValue, page: this.page }
      }).then(res => {
        if (res.data && res.data.status === 200) {
          const data = res.data.data || {}
          this.list = data.list || []
          this.total = data.total || 0
        } else {
          this.$msg.error((res.data && res.data.msg) || '加载失败')
        }
      }).catch(() => {
        this.$msg.error('加载失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.page = 1
      this.loadList()
    },
    switchType(t) {
      this.type = t
      this.page = 1
      this.loadList()
    },
    changePage(p) {
      this.page = p
      this.loadList()
    },
    isTop20(index) {
      return (this.page - 1) * this.pageSize + index + 1 <= 20
    },
    openDetail(item) {
      this.detailItem = item
      this.activeTab = 'files'
      this.bt = []
      this.jb = []
      this.fileGroups = {}
      this.fileGroupNames.forEach(g => {
        this.$set(this.fileGroups, g, { list: [], page: 1, total: 0, loading: false })
      })
      this.imgs = []
      this.imgPage = 1
      this.imgTotal = 0
      this.loadText()
      this.fileGroupNames.forEach(g => this.loadFiles(g, false))
      this.loadImgs(false)
    },
    backList() {
      this.detailItem = null
      this.playShow = false
    },
    loadText() {
      this.$ajax.post('api/v1/users/haowu/text', { id: this.detailItem.id }).then(res => {
        if (res.data && res.data.status === 200) {
          this.bt = res.data.bt || []
          this.jb = res.data.jb || []
        }
      }).catch(() => { })
    },
    loadFiles(group, more) {
      const g = this.fileGroups[group]
      if (!g || g.loading) return
      g.loading = true
      const page = more ? g.page + 1 : 1
      this.$ajax.post(
        `api/v1/users/haowu/info?page=${page}&type=${encodeURIComponent(group)}`,
        { id: this.detailItem.id }
      ).then(res => {
        if (res.data && res.data.status === 200) {
          const data = res.data.data || {}
          g.list = more ? g.list.concat(data.list || []) : (data.list || [])
          g.total = data.total || 0
          g.page = page
          this.kuaisuRemain = res.data.kuaisu_usenum != null ? res.data.kuaisu_usenum : this.kuaisuRemain
        } else {
          this.$msg.error((res.data && res.data.msg) || '加载失败')
        }
      }).catch(() => {
        this.$msg.error('加载失败，请稍后重试')
      }).finally(() => {
        g.loading = false
      })
    },
    loadImgs(more) {
      const page = more ? this.imgPage + 1 : 1
      this.imgLoading = true
      this.$ajax.post(`api/v1/users/haowu/imgs?page=${page}`, { id: this.detailItem.id }).then(res => {
        if (res.data && res.data.status === 200) {
          const data = res.data.data || {}
          this.imgs = more ? this.imgs.concat(data.list || []) : (data.list || [])
          this.imgTotal = data.total || 0
          this.imgPage = page
        } else {
          this.$msg.error((res.data && res.data.msg) || '加载失败')
        }
      }).catch(() => {
        this.$msg.error('加载失败，请稍后重试')
      }).finally(() => {
        this.imgLoading = false
      })
    },
    playFile(item) {
      this.playFileItem = item
      this.playShow = true
    },
    download(url, name) {
      if (!url) {
        this.$msg.warning('文件链接不存在')
        return
      }
      const link = document.createElement('a')
      link.href = url
      link.download = name || 'file'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    copy(context) {
      if (!context) {
        this.$msg.warning('没有可复制的内容')
        return
      }
      const done = () => this.$msg.success('复制成功')
      const fallback = () => {
        try {
          const oInput = document.createElement('textarea')
          oInput.value = context
          oInput.style.position = 'fixed'
          oInput.style.opacity = '0'
          document.body.appendChild(oInput)
          oInput.select()
          document.execCommand('Copy')
          done()
          oInput.remove()
        } catch (e) {
          this.$msg.error('复制失败')
        }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(context).then(done).catch(fallback)
      } else {
        fallback()
      }
    },
    makeFc() {
      const item = this.detailItem
      if (!item) return
      this.making = true
      this.$ajax.post('api/v1/users/haowu/make', {
        id: item.id,
        num: this.makeNum,
        surplus: item.surplus,
        uid: item.uid,
        name: item.name,
        fwq: item.fwq || ''
      }).then(res => {
        if (res.data && res.data.status === 200) {
          this.$msg.success(res.data.msg || '创建任务成功')
          this.makeDialog = false
          this.makeNum = 1
          item.dj = (item.dj || 0) + this.makeNum
        } else {
          this.$msg.error((res.data && res.data.msg) || '制作失败')
        }
      }).catch(() => {
        this.$msg.error('制作失败，请稍后重试')
      }).finally(() => {
        this.making = false
      })
    },
    quickFc() {
      const item = this.detailItem
      if (!item) return
      this.quicking = true
      this.$ajax.post('api/v1/users/haowu/kuaisu', {
        id: item.id,
        uid: item.uid,
        fwq: item.fwq || ''
      }).then(res => {
        if (res.data && res.data.status === 200) {
          this.kuaisuRemain = res.data.kuaisu_usenum != null ? res.data.kuaisu_usenum : this.kuaisuRemain
          const dz = res.data.data && res.data.data.dz
          if (dz) {
            this.previewUrl = dz
            this.previewShow = true
          }
          this.$msg.success('快速生成成功')
        } else {
          this.$msg.error((res.data && res.data.msg) || '快速生成失败')
        }
      }).catch(() => {
        this.$msg.error('快速生成失败，请稍后重试')
      }).finally(() => {
        this.quicking = false
      })
    },
    resetKuaisu() {
      this.$confirm('分享给好友可领取今日快速生成次数，是否前往分享页？', '领取次数', {
        confirmButtonText: '去分享',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push('/user2/share')
      }).catch(() => { })
    }
  },
  created() {
    this.loadTypes()
    this.loadList()
  }
}
</script>

<style scoped>
.tool-page { min-height: 100%; padding: 24px 24px 48px; background: #f5f7fa; box-sizing: border-box; }
.tool-content { max-width: 1180px; margin: 0 auto; padding-bottom: 48px; }
.tool-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
.tool-heading h2 { margin: 0 0 6px; color: #1e293b; font-size: 22px; }
.tool-heading p { margin: 0; color: #94a3b8; font-size: 13px; }
.tool-heading > span { padding: 11px; border-radius: 12px; background: #e8f1fe; color: #1a73e8; font-size: 28px; }
.tool-card { padding: 24px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); }

/* 搜索与分类 */
.search-bar { display: flex; gap: 10px; max-width: 420px; }
.type-tabs { display: flex; flex-wrap: wrap; gap: 8px; margin: 16px 0 22px; }
.type-chip { padding: 7px 16px; border: 1px solid #e2e8f0; border-radius: 20px; background: #f8fafc; color: #64748b; font-size: 13px; cursor: pointer; transition: .2s; }
.type-chip:hover { border-color: #93c5fd; color: #1a73e8; }
.type-chip.active { border-color: #1a73e8; background: #1a73e8; color: #fff; }

/* 商品卡片 */
.goods-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 16px; }
.goods-card { border: 1px solid #e2e8f0; border-radius: 12px; overflow: hidden; background: #fff; cursor: pointer; transition: all .2s; }
.goods-card:hover { transform: translateY(-3px); box-shadow: 0 10px 24px rgba(15,23,42,.1); }
.goods-cover { position: relative; height: 220px; overflow: hidden; }
.goods-new { position: absolute; top: 8px; right: 8px; z-index: 2; padding: 2px 9px; border-radius: 10px; background: #e11d48; color: #fff; font-size: 11px; font-weight: 700; box-shadow: 0 2px 8px rgba(225, 29, 72, .45); animation: goods-new-pulse 1.6s ease-in-out infinite; }
.goods-cover-img { display: block; width: 100%; height: 100%; }
.img-error { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: #c0c4cc; font-size: 26px; background: #f5f7fa; }
.goods-hover { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; background: rgba(15,23,42,.45); color: #fff; font-size: 13px; font-weight: 600; opacity: 0; transition: opacity .2s; }
.goods-card:hover .goods-hover { opacity: 1; }
.goods-hover .app-icon { font-size: 26px; }
.goods-info { padding: 12px 14px 14px; }
.goods-name { font-size: 14px; font-weight: 600; color: #1e293b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.goods-meta { display: flex; align-items: center; justify-content: space-between; margin-top: 8px; }
.goods-date { color: #94a3b8; font-size: 12px; }
.goods-dj { color: #94a3b8; font-size: 12px; }
.pagination-row { display: flex; justify-content: center; margin-top: 24px; }
@keyframes goods-new-pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.08); } }

/* 详情 */
.detail-back { display: inline-flex; align-items: center; gap: 4px; margin-bottom: 14px; color: #1a73e8; font-size: 13px; cursor: pointer; }
.detail-back .app-icon { font-size: 18px; }
.detail-header { display: flex; gap: 20px; padding: 24px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); margin-bottom: 18px; }
.detail-cover { width: 180px; height: 240px; border-radius: 10px; overflow: hidden; flex-shrink: 0; background: #f5f7fa; }
.detail-cover .el-image { width: 100%; height: 100%; }
.detail-main { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.detail-name { font-size: 18px; font-weight: 700; color: #1e293b; line-height: 1.5; }
.detail-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 14px; margin: 12px 0 18px; }
.detail-date { color: #94a3b8; font-size: 12px; }
.detail-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: auto; }
.btn-icon { font-size: 17px; margin-right: 3px; vertical-align: -4px; }
.detail-card { min-height: 320px; }

/* 文案 */
.text-list { display: flex; flex-direction: column; gap: 12px; }
.text-item { display: flex; align-items: flex-start; gap: 12px; }
.text-content { flex: 1; padding: 12px 14px; border-radius: 8px; background: #f8fafc; color: #475569; font-size: 13px; line-height: 1.7; word-break: break-all; white-space: pre-wrap; cursor: pointer; }

/* 视频素材 */
.file-section + .file-section { margin-top: 22px; }
.file-section-title { display: flex; align-items: center; gap: 6px; margin-bottom: 12px; color: #1e293b; font-size: 14px; font-weight: 600; }
.file-section-title .app-icon { font-size: 18px; color: #1a73e8; }
.file-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(170px, 1fr)); gap: 14px; }
.file-item { border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; }
.file-cover { position: relative; height: 130px; background: #f5f7fa; cursor: pointer; }
.file-cover .el-image { width: 100%; height: 100%; }
.file-play { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(15,23,42,.35); color: #fff; }
.file-play .app-icon { font-size: 40px; }
.file-name { padding: 8px 10px 4px; font-size: 12px; color: #475569; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.file-actions { display: flex; gap: 6px; padding: 0 10px 10px; }
.file-actions .el-button { flex: 1; margin: 0; }

/* 商品图 */
.imgs-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 10px; }
.img-item { width: 100%; height: 140px; border-radius: 8px; cursor: pointer; }
.load-more { display: flex; justify-content: center; margin-top: 20px; }

/* 弹窗 */
.make-box { display: flex; flex-direction: column; gap: 14px; }
.make-name { font-size: 15px; font-weight: 600; color: #1e293b; word-break: break-all; }
.make-row { display: flex; align-items: center; justify-content: space-between; color: #64748b; font-size: 14px; }
.make-total { color: #e11d48; font-size: 16px; }
.play-video { display: block; width: 100%; max-height: 70vh; background: #000; }
.play-audio { display: block; width: 100%; }
.preview-actions { display: flex; justify-content: center; gap: 10px; }
.preview-actions .el-button { margin: 0; }
.preview-empty { padding: 40px 0; text-align: center; color: #94a3b8; font-size: 14px; }

@media (max-width: 768px) {
  .tool-page { padding: 14px 14px 32px; }
  .tool-content { padding-bottom: 32px; }
  .tool-card { padding: 16px; }
  .search-bar { max-width: none; }
  .goods-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
  .goods-cover { height: 170px; }
  .detail-header { flex-direction: column; gap: 14px; padding: 16px; }
  .detail-cover { width: 100%; height: 220px; }
  .detail-actions { width: 100%; }
  .detail-actions .el-button { flex: 1; margin: 0; }
  .file-grid { grid-template-columns: repeat(2, 1fr); }
  .imgs-grid { grid-template-columns: repeat(3, 1fr); }
  .img-item { height: 110px; }
}

.goods-detail-link { display:none; }
.detail-actions { gap:10px; flex-wrap:wrap; }
.detail-actions .el-button { margin-left:0; }
@media(max-width:768px) {
 .goods-detail-link { display:flex; align-items:center; justify-content:space-between; color:#2563eb; font-size:12px; margin-bottom:8px; }
 .goods-hover { display:none; }
 .detail-actions { display:grid; grid-template-columns:minmax(0,1fr); }
 .detail-actions .el-button { width:100%; min-height:44px; white-space:normal; line-height:1.5; }
 .type-tabs { flex-wrap:nowrap; overflow-x:auto; padding-bottom:8px; }
 .type-chip { flex-shrink:0; }
}
</style>

<style>
/* 弹窗移动端宽度（弹窗挂载在 body 下，需全局样式） */
@media (max-width: 700px) {
  .haowu2-dialog { width: 92% !important; max-width: 460px; }
}

</style>



// WEBPACK FOOTER //
// src/components/User2/Haowu.vue